import React, { Component } from 'react'

import axios from 'axios'

import { Container } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';

import MenuBar from './components/MenuBar'
import Form from './components/Form'
import Report from './components/Report'

import './App.scss';

class App extends Component {
  constructor() {
    super()

    this.state = {
      appData: null,
      students: [],
      rooms: [],
      seatPlans: [],
      fromData: {},
      uploading: false,
      isReportGenerated: false
    }

    this.onExcelUpload = this.onExcelUpload.bind(this)
    this.generateSeatPlan = this.generateSeatPlan.bind(this)
  }

  componentDidMount = () => {
    this.fetchAppData()
  }

  fetchAppData = () => {
    axios.get('api/app.json')
      .then(res => {
        this.setState({
          appData: res.data
        })
      })
  }

  onExcelUpload = students => {
    if (students.length) {
      this.setState({
        students: students,
        uploading: false,
      })
    } else {
      this.setState({
        uploading: true,
        students: [],
      })
    }
  }

  generateSeatPlan = data => {
    const { students, appData } = this.state
    const mainArr = []
    let skip = 0
    data.rooms.forEach(r => {
      let rowStudents = []
      const rows = parseInt(r.rows) 
      const columns = parseInt(r.columns)
      const take = rows * columns
      const slicedStudents = students.slice(skip, (skip + take))
      skip += take
      const attendStudents = slicedStudents.map(s => {
        return {
          studentName: s.studentName,
          examRollNumber: s.examRollNumber
        }
      })
      for (let r = 0; r < rows; r++) {
        let colStudents = []
        let index = r
        for (let c = 0; c < columns; c++) {
          index += (c === 0 ? 0 : rows)
          if(index < slicedStudents.length){
            colStudents.push({
              studentName: slicedStudents[index].studentName,
              examRollNumber: slicedStudents[index].examRollNumber
            })
          }
        }
        rowStudents.push(colStudents)
      }
      mainArr.push({
        roomName: r.room_name,
        invigilator: r.invigilator,
        students: rowStudents,
        attendence: attendStudents
      })
    })
    // const jdata= JSON.stringify(mainArr)
    const formData = {
      date: data.date,
      time: data.time,
      duration: data.duration,
      level: data.level,
      program: data.program,
      semester: data.semester,
      subject: data.subject,
      subjectCode: data.subjectCode,
      ...appData
    }
    this.setState({
      fromData: formData,
      seatPlans: mainArr,
      isReportGenerated: true
    })
  }

  render = () => {
    const { appData, students, isReportGenerated, uploading, seatPlans, fromData } = this.state
    
    return (
      <div className="app-wrapper">
        <MenuBar onChange={this.onExcelUpload} appData={appData} />
        <Container className="body-container">
          {
            students.length ? (
              <React.Fragment>
                <div className="excel-counter">
                  <Alert severity="success">
                    There are total <strong>{students.length}</strong> students.
                  </Alert>
                </div>
                <Form onSubmit={this.generateSeatPlan} isReportGenerated={isReportGenerated} students={students} appData={appData} />
              </React.Fragment>
            ) : (
                <div className="excel-counter">
                  <Alert severity="info">
                    { uploading ? 'Uploading Sheet...' : 'Please Upload Sheet to Proceed.' }
                  </Alert>
                </div>
              )
          }
          
          {
            isReportGenerated && <Report seatPlans={seatPlans} fromData={fromData} />
          }
        </Container>
      </div>
    )
  }
}

export default App
